export const randomUsers = [ 
    {name:'Ahmad', avatar:0, job:'Compiler Programmar'},
    {name:'Gabriel', avatar:1, job:'Kernel Engineer'},
    {name:'Seth Richard', avatar:2, job:'Art Director'},
    {name:'Alan Young', avatar:3, job:'Graphic Designer'},
    {name:'Adam Joe', avatar:4, job:'Photographer'},
    {name:'John Doe', avatar:5, job:'Sofware Engineer'},
    {name:'Linda Patterson', avatar:6, job:'Backend Developer'},
    {name:'Henry Gray', avatar:7, job:'Co-founder of COM'},
    {name:'Jane Doe', avatar:8, job:'Compiler Programmer'},
    {name:'Ahmad', avatar:9, job:'Senior Software Engineer'},
    {name:'Dan Andrews', avatar:10, job:'Front-end Developer'},
    {name:'Clark Farmer', avatar:11, job:'Graphic Designer'},
    {name:'George Robertson', avatar:12, job:'C++ Programmer'},
    {name:'Ahmad', avatar:0, job:'CEO'},
    {name:'Barry Alan', avatar:13, job:'Photographer'},
    {name:'Ahmad', avatar:0, job:'Doctor'},
    {name:'Seth Richards', avatar:14, job:'Electrician'},
    {name:'Ramon Murray', avatar:15, job:'Technical Responsible'},
]

export const timeRanges = [
    {name:'Posted any time'},
    {name:'Last day', count:25},
    {name:'Last 3 days', count:150},
    {name:'Last week', count:300},
    {name:'Last 2 weeks', count:900},
    {name:'Last month', count:3583} ,
]

export const jobTypes = [
    {name:'All Job Types'},
    {name:'Full-time'},
    {name:'Part-time'},
    {name:'Contract'},
]

export const priceRanges = [
    {name:'$500'},
    {name:'$3000'},
    {name:'$10.000'},
    {name:'$50.000'},
    {name:'$100.000'},
    {name:'$150.000'},
    {name:'$300.000'},
]
